import { render, staticRenderFns } from "./ParameterPage.vue?vue&type=template&id=0889cf74&"
import script from "./ParameterPage.vue?vue&type=script&lang=js&"
export * from "./ParameterPage.vue?vue&type=script&lang=js&"
import style0 from "./ParameterPage.vue?vue&type=style&index=0&id=0889cf74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports